class {
    onCreate(input, out) {
        this.state = {
            isLoading: true,
            cards: null,
            defaultCard: null
        }
    }

    onMount() {
        this.fetchCardInfo()
    }

    fetchCardInfo() {
        const $this = this;
        
        $.ajax({
            method:'get',cache: false,
            url:'/payment_info',
            success:function(data){
                // console.log(data);
                if (data && data.cards) {
                    $this.state.cards = data.cards;
                    if (data.cards.length)
                        $this.state.defaultCard = data.cards[0].id;
                }
                $this.state.isLoading = false;
            }
        });
    }
}

<style>
    @media (max-width: 800px) {
        #aimatchModal .modal-dialog .modal-content .modal-body {
            background: none !important;
        }
        .ai-match-custom{
            display: none;
        }
    }
    #aimatchModal .modal-dialog .modal-content .modal-body {
        background-color: #EFF3F6;
        padding-top: 30px;
    }
</style>

<div class="modal fade dark-background-modal" tabindex="-1" role="dialog" id="aimatchModal">
    <div class=`modal-dialog modal-dialog-centered modal-lg` role="document">

        <div class="modal-content" style="background: #eff2f7;">
            <if(input.header)>
                <${input.header}/>
            </if>
            <div id="aimatchModalHeader" class="modal-header" style="border: none;padding-top: 25px;background-image: linear-gradient(to right, rgb(235 54 143), rgb(239, 68, 68), rgb(245, 158, 11));">
                <div class = "close-mbl" style = "display:none;"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <path d="M11.627 9.82635C12.1247 10.3244 12.1247 11.129 11.627 11.627C11.3787 11.8753 11.0527 12 10.7265 12C10.4006 12 10.0747 11.8753 9.82635 11.627L6.00014 7.80052L2.17394 11.627C1.92563 11.8753 1.59969 12 1.27375 12C0.947575 12 0.621633 11.8753 0.37333 11.627C-0.124443 11.129 -0.124443 10.3244 0.37333 9.82635L4.19977 6.00015L0.37333 2.17394C-0.124443 1.67593 -0.124443 0.871336 0.37333 0.37333C0.871336 -0.124443 1.67593 -0.124443 2.17394 0.37333L6.00014 4.19977L9.82635 0.37333C10.3244 -0.124443 11.129 -0.124443 11.627 0.37333C12.1247 0.871336 12.1247 1.67593 11.627 2.17394L7.80052 6.00015L11.627 9.82635Z" fill="#000"/>
                    </svg>
                </div>
                <div class="nk-block-head-content" style="padding: 10px 30px;">
                    <div style="display: flex;align-items: center;">
                        <h3 class="nk-block-title fw-normal" style="color: white;font-weight: bold !important;letter-spacing:0;">
                            <em class="icon ni ni-speed" style="margin-right: 8px;"></em>
                            Plixi <span style="font-weight: 500;">AI-Match™</span>
                        </h3>
                    </div>
                    <div class="nk-block-des">
                        <p class="lead" style="color: white;opacity: 75%;font-size: 15px;margin-top: 2px;">Train the AI engine to identify your ideal followers automatically</p>
                    </div>
                </div>
                <a href='#' class="close" style="opacity: 1;display: inline-flex;margin: auto 10px auto 0;">
                    <p style="font-weight: 500;color: white;font-size: 14px;margin-left: 6px;text-shadow: none;margin-top: 3px;background: #0000004d;padding: 12px 15px;white-space: nowrap;border-radius: 100px;">
                        <span style="letter-spacing: 0.3px;">$129/month</span>
                    </p>
                </a>
            </div>

            <div class="modal-body modal-body-lg">
                <video class = "ai-match-custom" autoplay="" loop="" muted="" style="width: 80%;position: absolute;right: -150px;clip-path: inset(2px 0 2px 0);top:0px;">
                    <source src="/images/match.mp4" type="video/mp4">
                        Your browser does not support the video tag.
                </video>
                
                <if(state.isLoading)>
                    <div class="spinner-grow" role="status" style="overflow: auto;margin: auto !important;position: absolute;top: 50px;left: 0;bottom: 0;right: 0;">
                        <span class="sr-only">Loading...</span>
                    </div>
                </if>
                <else>
                    <div class="row">
                        <div class="col-md-8 col-sm-12">
                            <h5 class="title" style='font-size: 30px;font-weight: 500;color: #0B1426;'></h5>
                            <h5 class="title pb-1" style="font-size: 30px;font-weight: 500;color: #0B1426;line-height: 35px;">Attract your ideal followers<br>up to <b>15x better</b> with <b>AI</b></h5>
                            <p style="letter-spacing: 0.25px;">Get more relevant Instagram followers using over<br><b>10M+ data points</b>. Simply train the AI engine by swiping left &amp; right on potential followers –&nbsp;just like Tinder!</p>
                        </div>
                        
                        <div class="col-md-12" style='margin-top: 30px;'>
                            <div id='aimatchAlertContainer' class='alert alert-fill alert-dismissible alert-icon' style='display:none;margin: 0 0 20px 0;'>
                                <em class='icon ni'></em> 
                                <strong></strong>            
                                <span></span>            
                                <button class="close" data-dismiss="alert"></button>
                            </div>

                            
                            <if(state.cards && state.cards.length)>
                                <div id='selectPaymentMethod'>
                                    <div style="display: inline-flex;width: 100%;justify-content: space-between;"><h6 style="line-height: 20px;font-size: 16px;" class="mb-4">Select your payment method<em class="ml-1 icon ni ni-lock-fill" style="color:#39d57c"></em></h6></div>
                                    <ul class="cc-pay-method mb-4" style="max-width: 380px;">
                                        <li class="cc-pay-dd dropdown" style="width: 100%;margin:0;">
                                            $ const defaultCard = state.cards[0] && state.cards[0].payment_source ? state.cards[0].payment_source : state.cards[0];
                                            $ {
                                                function cardIcon(card) {
                                                    if (!card.card) return "cc-alt-fill";
                                                    if (card.card.brand == 'visa') return "cc-visa"
                                                    else if (card.card.brand == 'mastercard') return "cc-mc"
                                                    else if (card.card.brand == 'american_express') return "american-express"
                                                    else if (card.card.brand == 'discover') return "cc-discover"
                                                    else if (card.card.brand == 'jcb') return "cb-jcb"
                                                    else if (card.card.brand == 'apple_pay') return "apple-pay"
                                                    else if (card.card.brand == 'google_pay') return "google-pay"
                                                    else return "cc-alt-fill";
                                                }
                                            }
                                            <a href="#" style="padding: 15px 30px;" class="btn btn-white btn-outline-light dropdown-toggle dropdown-indicator" data-toggle="dropdown" aria-expanded="false"><em class=`icon ni ni-${cardIcon(defaultCard)}`></em>
                                            <span><span class="cc-pay-star">**** **** **** </span> ${defaultCard.card.last4}</span></a>
                                            <div class="dropdown-menu dropdown-menu-auto" style="transform: translate3d(0px, 90px, 0px) !important;margin-top: 10px;">
                                                <ul class="link-list-plain">
                                                    <li><a href="#" class="cc-pay-item"><em class=`cc-pay-item-icon icon ni ni-${cardIcon(defaultCard)}`></em><span class="cc-pay-item-name"><span class="cc-pay-item-method"><span class="cc-pay-star">**** **** **** </span> ${defaultCard.card.last4}</span><span class="cc-pay-item-meta" style="text-transform:capitalize;">${defaultCard.card.brand.replace('_', ' ')}</span></span></a></li>
                                                    <for|card, index| of=state.cards>
                                                        <if (index > 0)>
                                                            <li><a href="#" class="cc-pay-item"><em class=`cc-pay-item-icon icon ni ni-${cardIcon(card)}`></em><span class="cc-pay-item-name"><span class="cc-pay-item-method"><span class="cc-pay-star">**** **** **** </span> ${card.payment_source.card.last4}</span><span class="cc-pay-item-meta" style="text-transform:capitalize;">${card.payment_source.card.brand.replace('_', ' ')}</span></span></a></li>
                                                        </if>
                                                    </for>
                                                    <!-- <li><a href=`javascript:$('#addNewCard').show();$('#selectPaymentMethod, #paymentModalButtonsWrapper').hide();mountStripe('${state.clientSecret.secret}');` class="cc-pay-item"><span class="cc-pay-item-name"><span class="cc-pay-item-method-new">Add New Card</span></span></a></li> -->
                                                </ul>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </if>   
                            <else>
                                <!-- No payment method on file -->
                            </else>

                            <input name='defaultCardId' value=state.defaultCard style="display:none"/> 

                        </div>
                        <div class="col-12">
                            <if(state.cards && state.cards.length)>
                                <button id="aimatchUpgradeButton" type="submit" style="margin-top: 20px;" class="btn btn-lg btn-primary">Turn on AI-Match™ <em class="icon ni ni-arrow-right" style="margin-left: 15px;"></em></button>
                            </if>
                            <else>
                                <!-- <button id="aimatchUpgradeButton" onclick="javascript:Intercom('showNewMessage')" type="button" style="margin-top: 20px;" class="btn btn-lg btn-primary">Contact Support <em class="icon ni ni-arrow-right" style="margin-left: 15px;"></em></button> -->
                                <a href="mailto:support@plixi.com" id="aimatchUpgradeButton" style="margin-top: 20px;" class="btn btn-lg btn-primary">Contact Support <em class="icon ni ni-arrow-right" style="margin-left: 15px;"></em></a>
                            </else>
                        </div>
                    </div>
                </else>

            </div>

        </div><!-- .modal-content -->
    </div><!-- .modal-dialog -->
</div><!-- .modal -->


<!-- AI-Match Upgrade Modal Script -->
<script type="text/javascript">
    document.addEventListener("DOMContentLoaded", function () {

        var loadingPayment = false, buttonAnimations=[], originalPaymentButtonText = $('#aimatchUpgradeButton').text();
        function setLoadingButton(isLoading) {
            loadingPayment = isLoading;
            var buttonStates = [ 'Processing...' ];
            $('#aimatchUpgradeButton').prop("disabled", isLoading);
            if (isLoading){
                $("#paymentModalCloseButton").hide()
                for (var i=0; i<buttonStates.length; i++){
                    const buttonText = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span><span>' + buttonStates[i] + '</span>'
                    buttonAnimations[i] = setTimeout(() => { $('#aimatchUpgradeButton').html(buttonText);}, 3200 * i);
                }
            }else {
                for (var i=0; i<buttonAnimations.length; i++)
                    clearTimeout(buttonAnimations[i])
                $('#aimatchUpgradeButton').html(`<span>${originalPaymentButtonText}</span><em class="icon ni ni-arrow-right"></em>`);
            }
        }
        function showAimatchError(msg_type, msg_body, msg_title) {
            var AlertMsg = $('#aimatchAlertContainer'), AlertIcon = $('#aimatchAlertContainer em');
            var alertClass = 'info', alertIcon = 'alert-circle';
            if (msg_type == 'error') {
                alertClass = "danger";
                alertIcon = "cross-circle"
            }else if (msg_type == 'success') {
                alertClass = "success";
                alertIcon = "check-circle"
            }
            if (msg_title) $(AlertMsg).find('strong').html(msg_title);
            $(AlertMsg).find('span').html(msg_body);
            $(AlertMsg).removeAttr('class');
            $(AlertMsg).addClass('alert alert-fill alert-dismissible alert-icon alert-' + alertClass);
            $(AlertIcon).removeAttr('class');
            $(AlertIcon).addClass('icon ni ni-' + alertIcon);
            $(AlertMsg).show();
            $('#aimatchAlertContainer').on('close.bs.alert', function (e) {e.preventDefault();$(this).hide();});
            setLoadingButton(false);
        }


        const aimatchModal = $('#aimatchModal');
        aimatchModal.on('show.bs.modal', function(){
            posthog.capture('ai_match_cta_clicked', {
                title: "User clicks enable ai match",
                origin:"client"
            })
            document.querySelector('#aimatchUpgradeButton').onclick = () => {
                if (loadingPayment) return;
                // if (!cardComponent.combinedField.status.isValid) return;
                originalPaymentButtonText = $('#aimatchUpgradeButton').text();
                setLoadingButton(true);
                $.ajax({
                    type: "POST",
                    url: '/account/' + selectedAccount.username + '/upgrade_addon',
                    data: {
                        addon: 'aimatch'
                    },
                    success: function(msg) {
                         posthog.capture('ai_match_purchased', {
                                title: "User purchases ai match",
                                origin:"client"
                            })
                        window.location.href = '/account/' + selectedAccount.username + '/match?aimatch_enabled=1'
                    },
                    error: function(chargeAddonError) {
                        console.log(chargeAddonError)
                        if(chargeAddonError.status == 401)
                            showAimatchError('error', "An error has occured while processing the upgrade! Please contact support!");
                        else
                            showAimatchError('error', chargeAddonError.responseJSON.error);
                    }
                });
            }
        })
    });
</script>


